export default __webpack_public_path__ + "static/media/Espaco.f103626f.jpg";